import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getQueryString, getUuid, consoleLogStyle } from './utils';

/**
 * 初始化从Storage获取参数
 */
export const initFromStorage = (ctx: any) => {
  try {
    ctx.sessionStore = JSON.parse(sessionStorage.getItem('jimoTrackerSessionStore') || '{}');

    if (ctx.sessionStore.sessionId) {
      ctx._mainObj.session_id = ctx.sessionStore.sessionId;
    } else {
      const sessionId = getUuid();
      ctx._mainObj.session_id = sessionId;
      ctx.sessionStore.sessionId = sessionId;
    }

    if (ctx.sessionStore.subSessionId) {
      ctx._mainObj.sub_session_id = ctx.sessionStore.subSessionId;
    }

    if (typeof ctx.sessionStore.eventSeq === 'number') {
      ctx._mainObj.parameters.event_seq = ctx.sessionStore.eventSeq;
    } else {
      ctx._mainObj.parameters.event_seq = -1;
      ctx.sessionStore.eventSeq = -1;
    }

    ctx._mainObj.parameters.channel_type = ctx.sessionStore.channelType;

    if (ctx.sessionStore.startSource) {
      ctx._mainObj.start_source = ctx.sessionStore.startSource;
    }

    if (ctx?._options?.enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'initFromStorage');
    }
  } catch { }
};

/**
 * 初始化从网址获取参数
 */
export const initFromUrl = (ctx: any) => {
  try {
    console.log(getQueryString('_jt_firstShare'), '44444444444_jt_firstShare');
    const channelType = decodeURIComponent(getQueryString('channel_type')) || undefined; // 后端消息类型
    const firstShare = decodeURIComponent(getQueryString('_jt_firstShare')) || undefined;
    const preShare = decodeURIComponent(getQueryString('_jt_preShare')) || undefined;
    console.log(firstShare, 'vue4444444444455_jt_firstShare');

    if (firstShare) {
      ctx.sessionStore.firstShare = firstShare;
    }

    if (preShare) {
      ctx.sessionStore.preShare = preShare;
    }

    // 如果链接中有 preShare 参数则说明是分享的链接，接受链接的人的 start_source 要设为分享人的 shareType
    const preShareArr = preShare ? preShare.split('.') : [];
    if (preShareArr.length) {
      ctx._mainObj.start_source = preShareArr[2];
      ctx.sessionStore.startSource = preShareArr[2];
    }

    if (channelType) {
      ctx._mainObj.parameters.channel_type = channelType;
      ctx.sessionStore.channelType = channelType;
    }
  } catch { }
};

/**
 * TODO: 设置当前设备浏览器指纹，deviceId为空率低于0.5%，与官方宣称的99.5%符合，如果想更好，可考虑收费版或者其他库
 */
export const setDeviceId = async (ctx: any) => {
  try {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    ctx._mainObj.device_id = result.visitorId;
    if (ctx?._options?.enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'setDeviceId:', result);
    }
  } catch { }
};
